export default "__VITE_ASSET__CAFDT1fz__"